<template>
  <div class="pageContainer">
    <img class="background-img" :src="currentBackground" alt="">
    <!-- 竖屏 -->
    <div class="info-h5">
      <div class="top-text">预约试驾</div>
      <el-form :inline="true" class="demo-form-inline" :model="driveForm" ref="driveForm">
        <el-form-item label="*所在省份">
          <el-select popper-class="my-select-style" v-model="driveForm.Province" placeholder="省份" @change="setProvince">
            <el-option v-for="(item, key) in alldata.province" :value="item.id" :key="key" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="*所在城市">
          <el-select popper-class="my-select-style" v-model="driveForm.City" placeholder="城市" no-data-text="无"
                     code-stm="event, PAGEURL, 切换城市信息mob" @change="cityChange">
            <el-option v-for="(item, key) in this.cascadingCities" :value="item.id" :key="key" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="*经销商">
          <el-select
            v-model="driveForm.DealerCode"
            placeholder="请选择经销商"
            no-data-text="无"
            @change="dealerChange"
            popper-class="select-option-dealer my-select-style"
          >
            <el-option
              v-for="item in cascadingDealers"
              :key="item.code"
              :value="item.code"
              :label="item.name"
              :disabled="item.isDisabled"
            >
              <template #default>
                <div style="display: flex;align-items: start;padding: 5px 0;">
                  <i v-if="driveForm.DealerCode === item.code" class="el-icon-check" style="padding-top: 10px;font-weight: 600;"></i>
                  <div v-else style="width: 14px;height: 14px;"></div>
                  <div style="padding-left: 6px;">
                    <div>{{ item.name }}</div>
                    <div class="ellipsis-text" style="color: rgba(180, 183, 192, 1);font-size: 12px;line-height: 20px;">{{ item.address }}</div>
                  </div>
                </div>
              </template>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="*车型">
          <!--   <el-select v-model="driveForm.CarSeriesCMSID" placeholder="请选择车型" @change="setCarSeries"> -->
          <el-select popper-class="my-select-style" v-model="driveForm.CarSeriesCMSID" placeholder="请选择车型" @change="setCarSeries">
            <el-option v-for="item in carAlldata.series" :key="item.name" :value="item.cmsid" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="*购车人姓名">
          <el-input v-model="driveForm.Name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="*购车人手机号">
          <el-input v-model="driveForm.Phone" placeholder="请输入手机号" maxlength="11"
                    oninput="if(value.length > 11) value=value.slice(0, 11)"></el-input>
        </el-form-item>
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="">
              <el-select
                v-model="driveForm.DealerCode"
                placeholder="请选择经销商"
                @change="dealerChange"
              >
                <el-option
                  v-for="(item, key) in this.cascadingDealers"
                  :key="key"
                  :value="item.code"
                  :label="item.name"
                  :disabled="(item.latitude==''&& item.longitude=='')?true:false"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->


        <el-row style="margin-top: 0px;">
          <el-form-item label="*短信验证码">
            <el-col :span="12">
              <el-input
                placeholder="请输入验证码"
                class="input"
                v-model="driveForm.verificationCode"
                maxlength="6"
                oninput="if(value.length > 6) value=value.slice(0, 6)"
              />
            </el-col>
            <el-col :span="12">
              <el-button
                class="button"
                @click="handleCaptchaButtonClick"
                code-stm="event, PAGEURL, 获取验证码mob"
                :class="{ disabled: !this.countDownCanClick }"
                :disabled="!this.countDownCanClick"
                style="height: 100%;font-size:calc(12 / 375 * 100vw);padding: 0;"
                >{{ countDownContent }}</el-button>
            </el-col>
          </el-form-item>
        </el-row>


        <el-row class="my-checkbox">
          <el-checkbox v-model="driveForm.checked" className="agreement-checkbox"  @change="checkboxChange">
            <span style="display: flex;color: #05141F99;white-space: nowrap;">
              已阅读并同意<span style="text-decoration: underline;color: #05141F;white-space: nowrap;" @click="read" code-stm="event, PAGEURL, 隐私协议">《隐私协议》</span>，且同意起亚经销商与我联系。
            </span>
          </el-checkbox>
        </el-row>

        <span class="submit-button" @click="submitInformation" code-stm="event, PAGEURL, 提交预约试驾表单信息mob">提交信息</span>
      </el-form>
    </div>
  </div>

</template>

<script>
import {getUrlKey, isPortraitFun, isAndroid, filterDealers, filterCarSeries} from "@/utils/utils.js";
import { apiUrl, pcdUrl, CSMUrl } from "@/config/base";
// import myBMap from "@/utils/myBMap";
import $ from "jquery";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      isAndroid: isAndroid(),
      alldata: null,
      carAlldata: null,
      closeIcon: require("@/assets/images/onepage/close.png"),
      // downArrowIcon: require("@/assets/images/footer/down-arrow.gif"),

      carModelSeries: [],
      cascadingCities: [],
      cascadingDealers: [],
      // canCheck: false,
      totalTime: 60,
      countDownContent: "获取验证码",
      countDownCanClick: true,
      clock: null,
      driveForm: {
        //试驾
        Phone: "",
        Name: "",
        verificationCode: "",
        Province: "",
        City: "",
        CarSeriesCMSID:'448',
        CarSeriesName: "全新赛图斯",
        // CarModelCMSID: "",
        // CarModelName: "",
        CarModelCMSID: "1686",
        CarModelName: "1.5L IVT 舒适版",

        DealerName: "",
        DealerCode: "",
        checked: false,
      },

      params: null, // 留资参数

      currentBackground:'/assets/~/media/images/activity/202604suchao/mob/liuzi-bg.jpg',
    };
  },
  props: {
    clientPosition: {
      type: Object,
      default: null,
    },
  },

  created: function () {
    if (!this.alldata) {
      this.$axios.get(pcdUrl).then((res) => {
        console.log("fetched alldata from created", res.data);
        const codesToKeep = [
          "HD349", "HD450", "HD328", "HD201", "XB317", "DB003", "HD358", "XB204", "XB308", "HD377",
          "HD291", "HD356", "XB201", "HD392", "HD407", "HZ340", "HD293", "XN502", "HD256", "XB309",
          "XN503", "HB320", "XB315", "XB303", "HD237", "XB318", "HB025", "HZ216", "DB006", "XB202",
          "HD298", "HD029", "XB207", "HN100", "HN202", "HD244", "HD606", "HB450", "HZ304", "HD115",
          "HB209", "HZ370", "HD346", "HD118", "XN251", "XB321", "HD289", "HD427", "XN423", "HN332",
          "HD608", "HZ441", "DB307", "HD355", "HD248", "HN423", "HD030", "HN333", "HD236", "HD180",
          "XN302", "DB335", "HZ041", "HB018", "XB004", "HB328", "HZ355", "HZ029", "HD500", "HZ042",
          "HZ375", "XB323", "HZ374", "XB224", "HB432", "HN087", "DB326", "XB325", "HD506", "XB305",
          "HZ376", "HD182", "DB336", "HN035", "HN094", "XB401", "DB338", "HD150", "HB462", "HD511",
          "HD512", "HD508", "XN310", "HD507", "HB430", "HB311", "HN092", "HD510", "HD324", "DB026",
          "XB219", "HB433", "HD443", "XN424", "HZ377", "HZ447", "HN076", "HD610", "HB460", "HB529",
          "XN259", "HN103", "XB226", "HB461", "HD181", "HD609", "XB326", "XB324", "HD183", "HD447",
          "XN260", "XN425", "XB227", "DB340", "DB339", "HD314", "HD184", "HD156", "HD375", "HD185",
          "HD028", "HZ371", "HB465", "DB322", "DB005", "HB530", "HB531", "HDA05", "XB312", "XB320",
          "XB329", "XB328", "XB316", "XB327"
        ];
        // filterDealers(res.data, codesToKeep);
        this.alldata = res.data;
        this.initData();
        // 数据加载完成后，初始化江苏省的城市列表
       // this.setCity();
      });
    }
    window.addEventListener("resize", this.setResize);
  },
  mounted() {
    this.$nextTick(() => {
      // console.log("获取位置");
      // this.getLocation()
    });
  },
  watch: {
    // 地址定位

    clientPosition: {
      handler(val) {
        // 防止定位完成省市信息没有加载完成
        if (!this.alldata) {
          this.$axios.get(pcdUrl).then((res) => {
            this.alldata = res.data;
            this.initData();
            if (val) {
              this.driveForm.Province = this.alldata.province.filter(
                (item) => item.name == val.province
              )[0].id;
              this.setCity(true);
              this.driveForm.City = this.alldata.city[
                this.driveForm.Province
                ].filter((item) => item.name == val.city)[0].id;
              this.cityChange(this.driveForm.City);
            }
          });
        } else {
          if (val) {
            this.driveForm.Province = this.alldata.province.filter(
              (item) => item.name == val.province
            )[0].id;
            this.setCity(true);
            this.driveForm.City = this.alldata.city[
              this.driveForm.Province
              ].filter((item) => item.name == val.city)[0].id;
            this.cityChange(this.driveForm.City);
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 触发共享验证码（从父组件）
    handleCaptchaButtonClick() {
      let parent = this.$parent;
      while (parent) {
        if (parent.handleCaptchaButtonClick && typeof parent.handleCaptchaButtonClick === 'function') {
          parent.handleCaptchaButtonClick('myform');
          break;
        }
        parent = parent.$parent;
      }
      if (!parent || !parent.handleCaptchaButtonClick) {
        const root = this.$root;
        if (root && root.handleCaptchaButtonClick && typeof root.handleCaptchaButtonClick === 'function') {
          root.handleCaptchaButtonClick('myform');
        }
      }
      const triggerButton = document.querySelector("#captcha-trigger-button");
      if (triggerButton) {
        triggerButton.click();
      }
    },
    // 重新初始化验证码（由父组件执行）
    reinitCaptcha() {
      let parent = this.$parent;
      while (parent) {
        if (parent.initCaptcha && typeof parent.initCaptcha === 'function') {
          parent.initCaptcha();
          return;
        }
        parent = parent.$parent;
      }
      const root = this.$root;
      if (root && root.initCaptcha && typeof root.initCaptcha === 'function') {
        root.initCaptcha();
      }
    },

    checkboxChange(e){
      if(e == true){
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '勾选', 1]);
      }else{
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '取消勾选', 1]);
      }
    },
    read() {
      this.$router.push({
        path: "/terms",
      });
    },
    toTerms() {
      this.$router.push({
        path: "/terms",
      });
    },
    handleCheckboxChange(e) {
      console.log("handleCheckboxChange");
      this.driveForm.checked = !this.driveForm.checked;
      if(e == true){
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '勾选', 1]);
      }else{
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '取消勾选', 1]);
      }
    },
    close() {
      this.$emit("close");
    },
    initData() {
      let that = this;
      // this.$axios.get(CSMUrl).then((res) => {
      //   console.log("车型车款数据", res.data);
      //   that.carAlldata = res.data;
      // });
      fetch(CSMUrl).then(function (response) {
        return response.json();
      }).then(function (data) {

        const filtercar = [
          "447","261","330"
        ];
        // filterCarSeries(data,filtercar);
        that.carAlldata = data;
      });
    },
    autoSet(a) {
      // let rs = this.clientPosition
      let rs = a;
      let theProv = this.alldata.province.find(
        (res) => res.name == rs.addressComponents.province
        //(res) => res.name == '江苏省'
      );
      this.driveForm.Province = theProv.id;
      //this.driveForm.Province = 10;
      this.setProvince();
      let theCity = this.cascadingCities.find(
        (res) => res.name == rs.addressComponents.city
      );
      this.driveForm.City = theCity.id;
      this.setCity();
    },
    setResize() {
      // console.log(13123, this.isPortrait);
      this.isPortrait = isPortraitFun();
    },
    setProvince() {
      this.driveForm.City = "";
      this.driveForm.DealerCode = "";
      this.driveForm.DealerName = "";
      this.cascadingDealers = [];
      this.setCity();
    },
    // setCity() {
    //   // this.cascadingCities = this.alldata.city[this.driveForm.Province];
    //   this.cascadingCities = [];
    //   this.alldata.city[this.driveForm.Province].forEach((cityIter) => {
    //     //过滤city
    //     if (
    //       this.alldata.cityRelType[cityIter.id].includes("1") ||
    //       this.alldata.cityRelType[cityIter.id].includes("4")
    //     ) {
    //       this.cascadingCities.push(cityIter);
    //     }
    //   });
    //   this.driveForm.City = this.driveForm.City || this.cascadingCities[0].id;
    //   this.cityChange(this.driveForm.City);
    // },
    setCity(fromLocation = false) {
      // 修复城市列表过滤逻辑，确保正确显示所选省份的城市
      this.cascadingCities = [];
      if (this.alldata.city[this.driveForm.Province]) {
        this.alldata.city[this.driveForm.Province].forEach((cityIter) => {
          // 过滤city，只显示有经销商的城市
          if (
            this.alldata.cityRelType[cityIter.id] &&
            (this.alldata.cityRelType[cityIter.id].includes("1") ||
            this.alldata.cityRelType[cityIter.id].includes("4"))
          ) {
            this.cascadingCities.push(cityIter);
          }
        });
      }

      if(!fromLocation){
        // 如果不是来自定位，则默认选中第一个城市
        this.driveForm.City = this.driveForm.City || (this.cascadingCities.length > 0 ? this.cascadingCities[0].id : "");
      }else{
        // 如果是来自定位但当前城市不在列表中，则清空城市选择
        if(this.cascadingCities.length > 0 && !this.cascadingCities.find((city) => city.id === this.driveForm.City)){
          this.driveForm.City = '';
        }
      }
      // 触发城市变化事件
      if (this.driveForm.City) {
        this.cityChange(this.driveForm.City);
      } else {
        this.cascadingDealers = [];
        this.driveForm.DealerCode = "";
        this.driveForm.DealerName = "";
      }
    },

    setCarSeries(e) {
      this.driveForm.CarModelCMSID = "";
      console.log(
        "this.driveForm.CarSeriesCMSID",
        this.driveForm.CarSeriesCMSID
      );
      if (this.driveForm.CarSeriesCMSID) {
        // this.driveForm.CarModelCMSID =
        //   this.carAlldata.model[this.driveForm.CarSeriesCMSID].at(-1).cmsid;
        // this.driveForm.CarModelName =
        //   this.carAlldata.model[this.driveForm.CarSeriesCMSID].at(-1).name;
        this.driveForm.CarModelCMSID =
          this.carAlldata.model[this.driveForm.CarSeriesCMSID][this.carAlldata.model[this.driveForm.CarSeriesCMSID].length - 1].cmsid;
        this.driveForm.CarModelName =
          this.carAlldata.model[this.driveForm.CarSeriesCMSID][this.carAlldata.model[this.driveForm.CarSeriesCMSID].length - 1].name;
      }
      console.log("this.driveForm.CarModelName", this.driveForm.CarModelName);

      //切换背景
      /**
      var background = this.backGroundList.find(
        (item) => item.id == e
      )?.background;
      this.currentBackground = background;
       **/
    },
    async cityChange(cityId) {
      if (!cityId) {
        this.cascadingDealers = [];
        this.driveForm.DealerCode = "";
        this.driveForm.DealerName = "";
        return;
      }

      // 加载百度地图
      let map = await this.load();
      let baiduMap = new map.Map();

      // 获取当前城市下的经销商数据
      let temp = this.alldata.dealer[cityId];
      this.cascadingDealers = [];

      if (temp) {
        temp.forEach((origin) => {
          if(origin.isException !== "是"){


          // 只显示类型为1或7的经销商
          if (origin.type == "1" || origin.type == "7") {
            let distance = null;
            // 如果有客户端位置信息，则计算距离
            if (this.clientPosition && this.clientPosition.lng && this.clientPosition.lat &&
                origin.latitude && origin.longitude) {
              try {
                const originPosition = new BMap.Point(
                  origin.latitude,
                  origin.longitude
                );
                const nowPosition = new BMap.Point(
                  this.clientPosition.lng,
                  this.clientPosition.lat
                );
                distance = this.getMapDistance(
                  nowPosition,
                  originPosition,
                  baiduMap
                );
              } catch (error) {
                console.error("计算距离时出错:", error);
              }
            }

            this.cascadingDealers.push({
              ...origin,
              distance: distance,
              isDisabled: origin.isException === "是",
            });
          }
          }
        });

        // 对经销商进行排序
        this.cascadingDealers = this.cascadingDealers.sort((a, b) => {
          // 首先处理 isException 的情况，未禁用的排在前面
          if (a.isException === "是" && b.isException !== "是") {
            return 1; // a 排在 b 后面
          } else if (a.isException !== "是" && b.isException === "是") {
            return -1; // b 排在 a 后面
          }

          // 如果都有距离信息，则按距离排序
          if (a.distance !== null && b.distance !== null) {
            return a.distance - b.distance;
          }

          // 如果只有其中一个有距离信息，则有距离的排在前面
          if (a.distance !== null && b.distance === null) {
            return -1;
          }
          if (a.distance === null && b.distance !== null) {
            return 1;
          }

          // 如果都没有距离信息，则保持原有顺序
          return 0;
        });
      }

      // 设置默认选中的经销商
      if (this.cascadingDealers.length > 0) {
        this.driveForm.DealerCode = this.cascadingDealers[0].code;
        this.driveForm.DealerName = this.cascadingDealers[0].name;
      } else {
        this.driveForm.DealerCode = "";
        this.driveForm.DealerName = "";
      }
    },
    getMapDistance(centerPoint, otherPoint, map) {
      let distance = map.getDistance(centerPoint, otherPoint);
      return (distance / 1000).toFixed(2);
    },
    findMinIndex(arr) {
      if (!Array.isArray(arr) || arr.length === 0) {
        return 0;
      }
      let minIndex = 0;
      for (let i = 1; i < arr.length; i++) {
        if (arr[i] < arr[minIndex]) {
          minIndex = i;
        }
      }
      return minIndex;
    },
    dealerChange(dealerCode) {
      let dealer = this.cascadingDealers.find((value) => {
        return value.code === dealerCode;
      });
      this.driveForm.DealerCode =
        dealer == null ? this.cascadingDealers[0].code : dealer.code;
      this.driveForm.DealerName =
        dealer == null ? this.cascadingDealers[0].name : dealer.name;
    },
    countDown(captchaVerifyParam) {
      if (!this.driveForm.Phone) {
        this.$message.error("请填写正确的手机号");
        this.reinitCaptcha();
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.driveForm.Phone)) {
        this.$message.error("请填写正确的手机号");
        this.reinitCaptcha();
        return;
      }
      if (!this.countDownCanClick) return;
      this.countDownCanClick = false;
      this.countDownContent = this.totalTime + "s后重试";
      this.clock = window.setInterval(() => {
        this.totalTime--;
        this.countDownContent = this.totalTime + "s后重试";
        if (this.totalTime < 0) {
          window.clearInterval(this.clock);
          this.countDownContent = "重新发送";
          this.totalTime = 60;
          this.countDownCanClick = true;
        }
      }, 1000);
      // 发送验证码（带阿里验证参数）
      const getCodeData = {
        phoneNumbers: this.driveForm.Phone,
        captchaVerifyParam,
      };
      this.$axios
        .post(`${apiUrl}sendMsg/cityTour/CaptchaSendVerificationCode`, getCodeData)
        .then((res) => {
          if (res.data.success) {
            this.$message.info("验证码发送成功，请注意查收");
          } else {
            this.$message.error(res.data.message);
          }
          this.reinitCaptcha();
        });
    },
    submitInformation() {
      console.log("this su");
      if (
        !this.driveForm.Name ||
        !this.driveForm.Phone ||
        !this.driveForm.verificationCode ||
        !this.driveForm.CarSeriesCMSID
      ) {
        this.$message.error("请完善信息后再次提交");
        return;
      }
      // 验证手机号
      if (!/^1[3456789]\d{9}$/.test(this.driveForm.Phone)) {
        this.$message.error("请填写正确的手机号");
        return;
      }
      //获取车型名字
      // console.log(this.carSeries)
      let CarSeriesName = this.carAlldata.series.find((item, index) => {
        return item.cmsid === this.driveForm.CarSeriesCMSID;
      });
      //获取默认经销商名字和编码
      if (!this.driveForm.DealerCode || !this.driveForm.DealerName) {
        this.driveForm.DealerCode = this.cascadingDealers[0].code;
        this.driveForm.DealerName = this.cascadingDealers[0].name;
      }
      //将省市转化成字符串
      let provinceStr = this.alldata.province.find(
        (item) => item.id === this.driveForm.Province
      );
      let cityStr = this.alldata.city[this.driveForm.Province].find(
        (item) => item.id === this.driveForm.City
      );
      provinceStr = provinceStr.name;
      cityStr = cityStr.name;

      if (!this.driveForm.checked) {
        this.$message.error(
          "请先同意已阅读并同意《隐私协议》，且同意起亚经销商与我联系"
        );
        return;
      }
      let currentYear= new Date().getFullYear();
      let  currentMonth = new Date().getMonth() + 1;
      let activename  = "苏超活动-预约试驾";

      let subFormDrive = {
        //媒体来源、活动来源、媒体渠道ID没写
        carModelCmsid: this.driveForm.CarModelCMSID,
        carModelName: this.driveForm.CarModelName,
        carSeriesCmsid: this.driveForm.CarSeriesCMSID,
        carSeriesName: CarSeriesName.name,
        cityName: cityStr,
        dealerCode: this.driveForm.DealerCode,
        dealerName: this.driveForm.DealerName,
        provinceName: provinceStr,
        userName: this.driveForm.Name,
        userPhone: this.driveForm.Phone,
        verificationCode: this.driveForm.verificationCode,
        smartCode: getUrlKey("utm_source") || "官网", //媒体来源
        activity: getUrlKey("utm_activity") || activename, //活动名称
        extraSix: getUrlKey("utm_soid") || "76",
      };
      // let subFormDrive = {
      //   //媒体来源、活动来源、媒体渠道ID没写
      //   CarSeriesCMSID: this.driveForm.CarModelCMSID,
      //   CarModelName: this.driveForm.CarModelName,
      //   CarModelCMSID: this.driveForm.CarSeriesCMSID,
      //   CarSeriesName: CarSeriesName.name,
      //   City: cityStr,
      //   DealerCode: this.driveForm.DealerCode,
      //   DealerName: this.driveForm.DealerName,
      //   Province: provinceStr,
      //   Name: this.driveForm.Name,
      //   Phone: this.driveForm.Phone,
      //   Code: this.driveForm.Code,
      //   SmartCode: getUrlKey("utm_source") || "官网", //媒体来源
      //   Activity: getUrlKey("utm_activity") || "EV5长续航上市", //活动名称
      //   ExtraSix: getUrlKey("utm_soid") || "76",
      // };
      //预约试驾接口
      this.$axios
        .post(`${apiUrl}clue/australiaPage`, subFormDrive)
        .then((res) => {
          // this.$axios.post(`${apiUrl}Clue/TestDriveSaveClue`,subFormDrive).then((res) => {
          console.log(99999998888, res);
          if (res.data.success) {
            this.$message.success("预约试驾成功");


            setTimeout(() => {
              this.driveForm.CarModelCMSID = "1686";
              this.driveForm.CarSeriesCMSID = "448";
              this.driveForm.CarModelName = "1.5L IVT 舒适版";
              this.driveForm.DealerCode = "";
              this.driveForm.DealerName = "";
              this.driveForm.Name = "";
              this.driveForm.Phone = "";
              this.driveForm.verificationCode = "";
              this.driveForm.City = "";
              this.driveForm.Province = "";
              this.driveForm.checked = false;
              // 重置倒计时
              window.clearInterval(this.clock);
              this.countDownContent = "获取验证码";
              this.totalTime = 60;
              this.countDownCanClick = true;
            }, 1000);
            _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),
              '活动留资线索提交成功', JSON.stringify(subFormDrive)]);
          } else {
            this.$message.error("预约试驾失败:" + res.data.message);
            _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),
              '活动留资线索提交失败', JSON.stringify(subFormDrive)]);
          }
        });
    },
    // 加载地图
    load() {
      return new Promise((resolve, reject) => {
        if (!this.BMap) {
          $.getScript(
            "//api.map.baidu.com/api?v=2.0&ak=4ybCJ1rBffkf2PFgkvsRJuqAV9XBtnHq&callback=initialize",
            function (res) {
             // console.log("百度", res);
              let num = 1;
              let time = setInterval(() => {
                if (BMap.Map) {
                  this.BMap = true;
                  resolve(BMap);
                  clearInterval(time);
                }
                num++;
              }, 25);
            }
          );
        } else {
          resolve(BMap);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.select-option-dealer .el-select-dropdown__item {
  height: auto !important;
  padding: 0 6px;
}
.select-option-dealer .el-select-dropdown__item.selected {
  font-weight: 500 !important;
}
.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100vw - 45px);
}
.pageContainer {
  position: relative;
  width: 100%;
  height: calc(2668 / 1500 * 100vw);
  .background-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(2668 / 1500 * 100vw);
  }
  .info-h5 {
    position: absolute;
    left: calc(54 / 1125 * 100vw);
    // bottom: calc(450 / 1125 * 100vw);
    top: calc(40 / 375 * 100vw);
    width: calc(1017 / 1125 * 100vw);
    padding: calc(90 / 1125 * 100vw) calc(99 / 1125 * 100vw) 0 calc(99 / 1125 * 100vw);
    // width: 100%;
    height: calc(1408 / 1125 * 100vw);
    border-radius: calc(40 / 1500 * 100vw);
   // border-top: 5px solid #d4e138;
    // margin-bottom: 40px;
    background-color: #ffffff;
    .top-text {
      font-size: calc(48 / 1125 * 100vw);
      padding-bottom: calc(26 / 1125 * 100vw);
      font-family: FZLanTingHeiS-B-GB;
    }

    ::v-deep .el-checkbox__label {
      margin-left: 0px;

      span {
        font-size: 10px;
      }
    }

    ::v-deep .el-input__inner {
      border: none;
      color: #05141F;
    }

    ::v-deep .el-checkbox__inner {
      border: 1px solid #05141F66 !important;
    }
  }
  ::v-deep .el-input__inner {
    height: 42px;
    line-height: 42px;
    font-size: calc(37 / 1125 * 100vw);
  }

  .el-button {
    height: 42px;
    background: #fff;
    color: #000;
  }

  .submit-button {
    height:  calc(120 / 1125 * 100vw);
    font-size: calc(40 / 1125 * 100vw);
    display: flex;
    align-items: center;
    justify-content: center;
    // padding: 10px 0;
    background-color: #000000;
    color: #FFFFFF;
  }

  .el-row {
    box-sizing: border-box;
    margin-top: 3%;
    display: flex;
    align-items: flex-end;
  }

  ::v-deep .el-form-item__content .inline-txt {
    position: absolute;
    line-height: 42px;
    padding: 0 10px;
    color: #05141F99;
  }
  .my-checkbox {
    padding: calc(34 / 1125 * 100vw) 0 calc(54 / 1125 * 100vw) 0;
  }
}


.el-button {
  width: 100%;
  background: #000000;
  border-radius: 0px;
  height: 50px;
  color: #fff;
  border: none;
}

::v-deep .el-checkbox__label span {
  display: block;
  color: #a7a7a7;
  margin-top: 15px;
  font-size: 12px;
}

::v-deep .el-checkbox__inner {
  background: transparent;
  border: 1px solid rgba($color: #000000, $alpha: 0.3);
}

::v-deep .el-form-item {
  margin: 0;
  width: 100%;
  display: flex;
  height: calc(121 / 1125 * 100vw);
  border-bottom:solid 1px #EEEEEE;
}

::v-deep .el-form-item__content {
  width: calc(570 / 1125 * 100vw);

  .inline-txt {
    position: absolute;
    line-height: 50px;
    padding: 0 10px;
    color: #3d3d3d;
  }
}

::v-deep .el-select {
  width: 100%;

  .el-input__inner {
    width: 43vw;
    height: calc(121 / 1125 * 100vw);
    // padding: 0 10px;
    padding:  0 0 0 calc(38 / 1125 * 100vw);
    background: transparent;
  }
}

::v-deep .el-input__inner {
  border-radius: 0px;
  // height: 50px;
  // line-height: 50px;
  height: calc(121 / 1125 * 100vw);
  background: transparent;
  border: none;
  color: #3d3d3d;
  padding:  0 0 0 calc(38 / 1125 * 100vw);
}

::v-deep .el-form--inline .el-form-item__label {
  display: block;
  text-align: left;
  color: #666666;
  font-size: calc(37 / 1125 * 100vw);
  width: calc(240 / 1125 * 100vw);
  padding: 0;
  white-space: nowrap;
}

::v-deep .el-checkbox__input {
  vertical-align: top;
}

::v-deep .el-checkbox__label span {
  display: block;
  margin-top: 0px;
  white-space: pre-wrap;
}

.agreement-checkbox {
  display: flex;
  align-items: center;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #05141F;
  border-color: #05141F;
}


</style>
